import {
  ENTERPRISE_ENGAGEMENT_DEFAULT_BASE,
  ENTERPRISE_ENGAGEMENT_PARTNER_BASE,
  ENTERPRISE_ENGAGEMENT_WORKSPACE_BASE,
  ENTERPRISE_PARTNER_GUEST_APPOINTMENTS,
  ENTERPRISE_PARTNER_OPS_APPOINTMENTS,
} from './engagementPortal';

/** Base path when mounted under main App.js; empty when `start:engagement` owns `/`. */
export { ENTERPRISE_ENGAGEMENT_PARTNER_BASE, ENTERPRISE_ENGAGEMENT_WORKSPACE_BASE, ENTERPRISE_ENGAGEMENT_DEFAULT_BASE };

export function getEngagementBase() {
  if (process.env.REACT_APP_TARGET === 'engagement') {
    return '';
  }
  if (typeof window !== 'undefined') {
    const path = window.location.pathname || '';
    if (path.startsWith(ENTERPRISE_ENGAGEMENT_PARTNER_BASE) || path === `${ENTERPRISE_ENGAGEMENT_PARTNER_BASE}/`) {
      return ENTERPRISE_ENGAGEMENT_PARTNER_BASE;
    }
    if (path.startsWith(ENTERPRISE_ENGAGEMENT_WORKSPACE_BASE) || path === `${ENTERPRISE_ENGAGEMENT_WORKSPACE_BASE}/`) {
      return ENTERPRISE_ENGAGEMENT_WORKSPACE_BASE;
    }
    if (path.startsWith(ENTERPRISE_PARTNER_GUEST_APPOINTMENTS)) {
      return ENTERPRISE_PARTNER_GUEST_APPOINTMENTS;
    }
    if (path.startsWith(ENTERPRISE_PARTNER_OPS_APPOINTMENTS)) {
      return ENTERPRISE_PARTNER_OPS_APPOINTMENTS;
    }
  }
  return ENTERPRISE_ENGAGEMENT_DEFAULT_BASE;
}

/** @deprecated use getEngagementBase() — kept for imports that expect a constant default mount */
export const ENTERPRISE_ENGAGEMENT_BASE = ENTERPRISE_ENGAGEMENT_DEFAULT_BASE;

export function engagementPath(subpath = '') {
  const base = getEngagementBase();
  const tail = String(subpath || '').replace(/^\/+/, '');
  if (!base) {
    return tail ? `/${tail}` : '/';
  }
  const normalized = base.replace(/\/+$/, '');
  return tail ? `${normalized}/${tail}` : normalized;
}

const LIST_FILTER_SEGMENTS = new Set(['', 'leads', 'appointments', 'conversations', 'human-intervention', 'call-records']);
const AUTOMATION_TAB_ALIASES = {
  reminders: 'automations',
  builtin: 'automations',
  custom: 'automations',
  history: 'messages',
  settings: 'safety',
};

/** Shared multi-select bar: salon lists, plus Automations (its 30-day numbers), “Sent and waiting” and “People in a flow”. */
export function engagementBranchFilterOn(pathname, search) {
  const segment = engagementFirstSegment(engagementRelativePath(pathname));
  if (LIST_FILTER_SEGMENTS.has(segment)) return true;
  if (segment !== 'automations') return false;
  const raw = new URLSearchParams(search || '').get('tab') || '';
  const tab = AUTOMATION_TAB_ALIASES[raw] || raw || 'automations';
  return tab === 'automations' || tab === 'messages' || tab === 'runs';
}

export function engagementFirstSegment(splat) {
  const trimmed = String(splat || '').replace(/^\/+|\/+$/g, '');
  if (!trimmed) return '';
  return trimmed.split('/')[0];
}

/** Path after the engagement mount base (partner or /nyafaz-ep/engagement). */
export function engagementRelativePath(pathname) {
  const path = String(pathname || '');
  const bases = [
    ENTERPRISE_PARTNER_GUEST_APPOINTMENTS,
    ENTERPRISE_PARTNER_OPS_APPOINTMENTS,
    ENTERPRISE_ENGAGEMENT_PARTNER_BASE,
    ENTERPRISE_ENGAGEMENT_WORKSPACE_BASE,
    ENTERPRISE_ENGAGEMENT_DEFAULT_BASE,
  ];
  for (const base of bases) {
    const normalized = base.replace(/\/+$/, '');
    if (path === normalized || path === `${normalized}/` || path.startsWith(`${normalized}/`)) {
      return path.slice(normalized.length).replace(/^\/+|\/+$/g, '');
    }
  }
  return '';
}
